// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__WDW12","dash":"Menu_dash__2WEIf","searchContainer":"Menu_searchContainer__j+g1e","search":"Menu_search__JJI1A","item":"Menu_item__oxcrM"};